/**
 * Load svg via ajax
 * @param  {string} url path to svg sprite
 * @generator: webpack-svgstore-plugin
 * @see: https://www.npmjs.com/package/webpack-svgstore-plugin
 * @return {[type]}     [description]
 */

/**
 * jQuery like $.ready function.
 *
 * @param {Function} fn
 * @return void
 */
function domready(callback) {
  if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', callback);
  }
}

const svgXHR = function (options) {
  let url = false;
  let baseUrl;
  console.log('We have the options: ', options);

  options && options.filename ? (url = options.filename) : null;

  if (!url) return false;
  let _ajax = new XMLHttpRequest();
  let _fullPath;

  if (typeof XDomainRequest !== 'undefined') {
    _ajax = new XDomainRequest();
  }

  if (typeof baseUrl === 'undefined') {
    if (typeof window.baseUrl !== 'undefined') {
      baseUrl = window.baseUrl;
    } else {
      baseUrl = `${window.location.protocol
      }//${
        window.location.hostname
      }${window.location.port ? `:${window.location.port}` : ''}`;
    }
  }

  _fullPath = (`${baseUrl}/${url}`).replace(/([^:]\/)\/+/g, '$1');
  _ajax.open('GET', _fullPath, true);
  _ajax.onprogress = function () {};
  _ajax.onload = function () {
    if (!_ajax.responseText || _ajax.responseText.substr(0, 4) !== '<svg') {
      throw Error('Invalid SVG Response');
    }
    if (_ajax.status < 200 || _ajax.status >= 300) {
      return;
    }
    const div = document.createElement('div');
    div.innerHTML = _ajax.responseText;

    if (options && options.divId) {
      console.log('We have the ID: ', options.divId);
      div.setAttribute('id', options.divId);
    }

    if (options && options.class) {
      div.classList.add(options.class.join(' '));
    }

    domready(() => {
      document.body.insertBefore(div, document.body.childNodes[0]);
    });
  };
  _ajax.send();

  return true;
};

// module.exports = svgXHR;
export default svgXHR;
